import { enableProdMode, importProvidersFrom } from "@angular/core";
import { environment } from "./environments/environment";
import { AppComponent } from "./app/app.component";
import { appRoutes } from "./app/app.routes";
import { MatDialogModule } from "@angular/material/dialog";
import { provideAnimations } from "@angular/platform-browser/animations";
import { BrowserModule, bootstrapApplication } from "@angular/platform-browser";
import { SettingLocalStorageRepository } from "./app/user-settings/repository/setting-local-storage-repository";
import { SU_DATE_FORMAT, SU_TIME_FORMAT } from "@susoft/ngx-susoft-ui/input";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MAT_SELECT_CONFIG } from "@angular/material/select";
import { MY_FORMATS } from "./app/common/utils/date-utils";
import { DayjsDateAdapter } from "./app/common/adapters/dayjs-date.adapter";
import { DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS } from "@angular/material/core";
import { ApiUrlInterceptor } from "./app/common/interceptors/api-url-interceptor";
import { HTTP_INTERCEPTORS, withInterceptorsFromDi, provideHttpClient } from "@angular/common/http";
import { DatePipe, DecimalPipe, CommonModule } from "@angular/common";
import { provideRouter, withInMemoryScrolling } from "@angular/router";
import { CalendarModule, DateAdapter as CalendarDateAdapter } from "angular-calendar";
import { adapterFactory } from "angular-calendar/date-adapters/date-fns";

if (environment.production) {
	enableProdMode();
	// Disabling debug mode
	console.debug = () => {

	};
}

bootstrapApplication(AppComponent, {
    providers: [
        importProvidersFrom(BrowserModule, CommonModule, MatDialogModule),
        importProvidersFrom(CalendarModule.forRoot({
            provide: CalendarDateAdapter,
            useFactory: adapterFactory
        })),
        provideRouter(appRoutes, withInMemoryScrolling({ anchorScrolling: 'enabled' })),
        DatePipe,
        DecimalPipe,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: ApiUrlInterceptor,
            multi: true
        },
        { provide: DateAdapter, useClass: DayjsDateAdapter, deps: [MAT_DATE_LOCALE] },
        { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
        { provide: MAT_SELECT_CONFIG, useValue: { disableOptionCentering: 'false' } },
        MatSnackBar,
        {
            provide: SU_DATE_FORMAT,
            // Return a getter function so the component always reads the most
            // recent value from localStorage (set by common.service.ts on login).
            useValue: () => SettingLocalStorageRepository.getDateFormat() ?? 'dd/MM/YYYY'
        },
        {
            provide: SU_TIME_FORMAT,
            // Return a getter function so the component always reads the most
            // recent value from localStorage (set by common.service.ts on login).
            useValue: () => SettingLocalStorageRepository.getClockFormat() ?? 24
        },
        provideAnimations(),
        provideHttpClient(withInterceptorsFromDi())
    ]
})
	.catch((err) => console.error(err));
